'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var X = function X(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 10 10' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'x'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'nonzero' },
        _react2.default.createElement('path', { d: 'M9.081.596L.596 9.081a.5.5 0 1 0 .707.708L9.79 1.303A.5.5 0 0 0 9.08.596z' }),
        _react2.default.createElement('path', { d: 'M9.789 9.081L1.303.596a.5.5 0 0 0-.707.707L9.081 9.79a.5.5 0 1 0 .708-.708z' })
      )
    )
  );
};
/*eslint-enable */

exports.default = X;
//# sourceMappingURL=X.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/X.js